import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { studioThemeMessages } from '../../studio/studioThemeMessages';
import { ONE_OFF_CHANNEL_NAMES } from '../../publish/publishBadgeText';
import { StaleChannelNote } from './kitSlots';
import { kitMessages } from './kitMessages';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './Kit.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The note under the grid (design assets-rethink b4): "r2 of the lyric video is not on YouTube.
 * YouTube shows r1." A badge belongs to the revision that went out; a new revision does not move it.
 */
const KitStaleNotesComponent: React.FC<{ notes: StaleChannelNote[] }> = ({ notes }) => {
  const intl = useIntl();
  if (notes.length === 0) {
    return null;
  }
  return (
    <>
      {notes.map((note) => (
        <div key={`${note.themeId}:${note.channel}`} className={styles.note} data-testid="kit-stale-note">
          {intl.formatMessage(kitMessages.staleChannel, {
            current: note.current,
            published: note.published,
            name: intl.formatMessage(studioThemeMessages[note.themeId].name).toLowerCase(),
            channel: ONE_OFF_CHANNEL_NAMES[note.channel],
          })}
        </div>
      ))}
    </>
  );
};

export const KitStaleNotes = TypedMemo(KitStaleNotesComponent);
